/**
 * Web / Vite: backend URL and optional function key from import.meta.env.
 * React Native resolves `runtimeEnv.native.ts` instead — no import.meta in the Hermes bundle.
 */
export function setSharedBackendEnv(_url: string, _apiKey: string): void {}

export function getBackendApiUrl(): string {
  return import.meta.env.VITE_BACKEND_API_URL as string;
}

export function getBackendApiKey(): string {
  return (import.meta.env.VITE_BACKEND_API_KEY as string) ?? '';
}
